import getStore from 'services/getStore';
import getTopics from 'services/apiHelpers/getTopics';

export default () => {
  const state = getStore().getState();

  return getTopics().find(t => t.id === state.currentTopic);
};
